export default __webpack_public_path__ + "static/media/tokpedLogo.f3603a4b.png";